import { ApiSuccessIndicationEnum } from '../enums';

export function mapSuccessIndication(success: boolean): ApiSuccessIndicationEnum {
    return success ? ApiSuccessIndicationEnum.Success : ApiSuccessIndicationEnum.Error;
}

export function mapFromSuccessIndication(successIndication: ApiSuccessIndicationEnum): boolean {
    return successIndication === ApiSuccessIndicationEnum.Success;
}
